import { createAction } from '@reduxjs/toolkit'

import type { OrderGift } from '@/entities/order/types/types'

export type SetGiftCardPayload = {
	GIFT_CARD_ID?: string
	GIFT_CARD_CVV?: string
	GIFT_CARD_AMOUNT?: number
}

export const setGiftCardEvent = createAction<SetGiftCardPayload>('order/check/card')

export const setGiftsEvent = createAction<{
	gifts: OrderGift[]
}>('order/set-gifts')
